import { useEffect, useState } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { Home, Dashboard, TermsOfService, NotAPartnerYetScreen } from "./pages";
import { useAppContext } from "./contexts/AppContextProvider";

const App = () => {
  const { isLoggedIn, isAuthChecking, partnerInfo } = useAppContext();
  const [theme] = useState(localStorage.getItem("theme") || "dark");

  useEffect(() => {
    localStorage.setItem("theme", theme);

    if (theme === "dark") {
      document.documentElement.classList.add("dark");
    } else {
      document.documentElement.classList.remove("dark");
    }
  }, [theme]);

  // Show a full-screen spinner while the initial auth-check is in flight
  if (isAuthChecking) {
    return (
      <div
        className="w-full h-screen flex items-center justify-center"
        style={{ background: "var(--background-main)" }}
      >
        <div
          className="w-10 h-10 border-4 border-t-transparent rounded-full animate-spin"
          style={{
            borderColor: "var(--border-color)",
            borderTopColor: "#059669",
          }}
        />
      </div>
    );
  }

  return (
    <div>
      <ToastContainer position="bottom-center" className="text-center z-50" />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route
          path="/dashboard/*"
          element={
            isLoggedIn ? (
              partnerInfo?.partnerId || partnerInfo?.partnerType ? (
                <Dashboard />
              ) : (
                <Navigate replace to="/partner-onboarding" />
              )
            ) : (
              <Navigate replace to="/" />
            )
          }
        />
        <Route path="/terms-of-service" element={<TermsOfService />} />
        <Route path="/partner-onboarding" element={<NotAPartnerYetScreen />} />

        <Route path="*" element={<Navigate replace to="/" />} />
      </Routes>
    </div>
  );
};

export default App;
